import FolderColorPicker from 'library/components/form/color-radio';
import Input from 'library/components/form/input';
import { Content } from './styles';
import withFormContainer from './hocs/with-form-container';

const FolderConfiguration = ({
  placeholder, text, name = 'name', defaultValues,
}) => (
  <Content>
    <Input placeholder={placeholder} iconClassName="icon-pencil" name={name} defaultValue={defaultValues?.name} />
    <FolderColorPicker label={text} name="color" defaultValue={defaultValues?.color} />
  </Content>
);
export default withFormContainer(FolderConfiguration);
